export default __webpack_public_path__ + "static/our-community-eef3895c041845b764c2c556d950bb17.mp4";